export const setNavLocalState = (value) => {
  localStorage.setItem('is-nav-collapsed', value);
};

export const getNavLocalState = () => {
  const value = localStorage.getItem('is-nav-collapsed');
  if (value === null) return true;
  return value === 'true';
};
